import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import Seo from "@/components/common/Seo";
import { HospitalCard, JourneyCard, OrganCard, StateCard } from "@/components/common/Cards";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [res, setRes] = useState(null);

  useEffect(() => {
    if (!q) { setRes({ organs: [], states: [], centres: [], journeys: [] }); return; }
    setRes(null);
    api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setRes(r.data));
  }, [q]);

  const total = res ? res.organs.length + res.states.length + res.centres.length + res.journeys.length : 0;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <Seo title={`Search: ${q} — Transplant Story`} />
      <div className="text-[11px] font-mono uppercase tracking-widest text-neutral-400 mb-3">Search results</div>
      <h1 className="text-3xl sm:text-5xl font-light tracking-tight text-ink">"{q}"</h1>

      {!res ? (
        <p className="text-neutral-500 mt-10">Searching…</p>
      ) : total === 0 ? (
        <p className="text-neutral-500 mt-10">No results found. Try an organ, a state, or a city.</p>
      ) : (
        <div className="space-y-14 mt-12">
          {res.organs.length > 0 && (
            <Group title="Organs">
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
                {res.organs.map((o) => <OrganCard key={o.slug} organ={{ ...o, centre_count: 0, journey_count: 0 }} />)}
              </div>
            </Group>
          )}
          {res.states.length > 0 && (
            <Group title="States & Union Territories">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {res.states.map((s) => <StateCard key={s.code} state={{ ...s, centre_count: 0, journey_count: 0 }} />)}
              </div>
            </Group>
          )}
          {res.centres.length > 0 && (
            <Group title="Transplant centers">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {res.centres.map((c) => <HospitalCard key={c.id} centre={c} />)}
              </div>
            </Group>
          )}
          {res.journeys.length > 0 && (
            <Group title="Patient journeys">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {res.journeys.map((j) => <JourneyCard key={j.id} journey={j} />)}
              </div>
            </Group>
          )}
        </div>
      )}
    </div>
  );
}

function Group({ title, children }) {
  return (
    <section>
      <h2 className="text-[11px] font-mono uppercase tracking-widest text-neutral-500 mb-5">{title}</h2>
      {children}
    </section>
  );
}
